import React from 'react'
import { SlideDown } from 'react-slidedown'
import PropTypes from 'prop-types'
import 'react-slidedown/lib/slidedown.css'

class ElementHeightAnimator extends React.Component {
  constructor (props) {
    super(props)
    this.slider = React.createRef()
  }

  componentDidMount () {
    this.slider.current.addEventListener('transitionend', e => {
      if (e.propertyName === 'height') {
        if (this.props.open) {
          this.props.onAfterOpen(e)
        } else {
          this.props.onAfterClose(e)
        }
      }
    })
  }

  render () {
    return (
      <SlideDown
        className={`ElementHeightAnimator ${this.props.sliderClass}`}
        closed={!this.props.open}
        ref={this.slider}
      >
        {this.props.children}
      </SlideDown>
    )
  }
}

ElementHeightAnimator.defaultProps = {
  onAfterClose: () => {},
  onAfterOpen: () => {}
}

ElementHeightAnimator.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onAfterClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  sliderClass: PropTypes.string
}

export default ElementHeightAnimator
